import React, { useEffect, useRef, useState } from "react";
import "../DashBoard/dashboard.css";
import { Box, Button, Slider, TextField } from "@mui/material";
import { Field, Form, Formik } from "formik";
import creditRatingService from "../../components/Services/creditRating.service";
import { useDispatch, useSelector } from "react-redux";
import { getAllEnergyTypes } from "../../store/ConsumerCapacity/action";

const Filter = ({
 getMatchingProfiles,
 selectedCardData,
 getMatchingProfilesCon,
 formResetFlag,
 setFIlterModal,
}) => {
 const [credit, setCredit] = useState([]);

 const dispatch = useDispatch();
 const formikRef = useRef();
 const role = useSelector((state) => state?.sessionState?.role);
 const energyTypes = useSelector(
  (state) => state?.consumerCapacityReducer?.energyTypes
 );

 const creditRating = () => {
  creditRatingService.getAllCreditRating().then((response) => {
   if (response) {
    setCredit(response?.data?.data);
   }
  });
 };

 const initialValues = {
  energy: [null, null],
  matchPercentage: "",
  energyRate: "",
  sellingCost: [null, null],
  landingCostRange: [null, null],
  creditRatingId: "",
  connectionStatus: "",
  energyTypeId: "",
 };
 const handleFormReset = () => {
  if (role === "GENERATOR") {
   getMatchingProfiles(selectedCardData?.id);
  } else if (role === "CONSUMER") {
   getMatchingProfilesCon(selectedCardData?.id);
  }
 };
 useEffect(() => {
  creditRating();
  getAllEnergyTypes()(dispatch);
 }, []);
 useEffect(() => {
  formikRef.current.resetForm();
 }, [formResetFlag]);
 return (
  <>
   <Formik
    innerRef={formikRef}
    initialValues={initialValues}
    onSubmit={(values, { setSubmitting }) => {
     const filteredData = {
      energy: {
       operation: "BETWEEN",
       key: role === "CONSUMER" ? "sellEnergy" : "purchaseEnergy",
       value: values.energy[0],
       value1: values.energy[1],
      },
      matchPercentage: {
       operation: "BETWEEN",
       key: "matchPercentage",
       value: 0,
       value1: values.matchPercentage,
      },
      sellingCost: {
       operation: "BETWEEN",
       key: "sellingCost",
       value: values.sellingCost[0],
       value1: values.sellingCost[1],
      },
      energyRate: {
       operation: "BETWEEN",
       key: "energyRate",
       value: 0,
       value1: values.energyRate,
      },
      landingCostRange: {
       operation: "BETWEEN",
       key: "landingCost",
       value: values.landingCostRange[0],
       value1: values.landingCostRange[1],
      },
      creditRatingId: {
       operation: "LIKE",
       key:
        role === "CONSUMER"
         ? "generatorPlant_company_creditRating_id"
         : "consumerDetail_company_creditRating_id",
       value: values.creditRatingId,
       value1: null,
      },
      connectionStatus: {
       operation: "LIKE",
       key:
        values.connectionStatus === "PLACED" || values.connectionStatus == ""
         ? role === "CONSUMER"
           ? "bids_consumerStatus"
           : "bids_generatorStatus"
         : role === "CONSUMER"
         ? "bids_generatorStatus"
         : "bids_consumerStatus",
       value: values.connectionStatus,
       value1: null,
      },
      consumerEnergyTypeId: {
       operation: "LIKE",
       key: "energyType_id",
       value: +values.energyTypeId,
      },
      generatorEnergyTypeId: {
       operation: "LIKE",
       key: "generatorPlant_energyType_id",
       value: +values.energyTypeId,
      },
     };
     const reqBody = {
      search: [
       values.energy[0] !== null &&
        values.energy[1] !== null &&
        filteredData?.energy,
       values.sellingCost[0] !== null &&
        values.sellingCost[1] !== null &&
        filteredData?.sellingCost,
       values.matchPercentage && filteredData.matchPercentage,
       values.energyRate && filteredData.energyRate,
       values.landingCostRange[0] !== null &&
        values.landingCostRange[1] !== null &&
        filteredData.landingCostRange,
       values.creditRatingId && filteredData.creditRatingId,
       values.connectionStatus !== "" && filteredData.connectionStatus,
       values.energyTypeId &&
        (role === "CONSUMER" || role === "UN_VERIFIED_CONSUMER"
         ? filteredData?.generatorEnergyTypeId
         : role === "GENERATOR" || role === "UN_VERIFIED_GENERATOR"
         ? filteredData?.consumerEnergyTypeId
         : false),
      ].filter(Boolean),
     };
     if (role === "GENERATOR") {
      getMatchingProfiles(selectedCardData?.id, reqBody);
     } else if (role === "CONSUMER") {
      getMatchingProfilesCon(selectedCardData?.id, reqBody);
     }
     setSubmitting(false);
    }}
   >
    {({ values, errors, setFieldValue, setFieldTouched, resetForm }) => {
     return (
      <Form>
       <div className="dashboard-filter">
        <div className="d-flex justify-content-between align-items-center mt-2">
         <h5>Filters</h5>
         <Button
          className="mb-0"
          variant="text"
          color="warning"
          size="small"
          onClick={() => {
           resetForm();
           handleFormReset();
           setFIlterModal(false);
          }}
         >
          <u>Clear all</u>
         </Button>
        </div>
        <div className="filter-inputLabel">
         <p className="filter-inputLabelText">Quantity (in MW)</p>
        </div>
        <div className="filter-slider">
         <Box>
          <Slider
           className="matchPercentage"
           name="energy"
           getAriaLabel={() => "Temperature range"}
           value={values.energy}
           max={10000}
           onChange={(e) => {
            setFieldValue("energy", e.target.value);
           }}
           valueLabelDisplay="on"
           color="warning"
           size="small"
          />
         </Box>
        </div>
        {role === "CONSUMER" && (
         <>
          <div className="filter-inputLabel">
           <p className="filter-inputLabelText">Energy Rate (₹ per Unit)</p>
          </div>
          <div className="filter-slider">
           <Box>
            <Slider
             className="matchPercentage"
             name="sellingCost"
             getAriaLabel={() => "Temperature range"}
             value={values.sellingCost}
             onChange={(e) => {
              setFieldValue("sellingCost", e.target.value);
             }}
             valueLabelDisplay="on"
             color="warning"
             size="small"
            />
           </Box>
          </div>
         </>
        )}
        {role === "GENERATOR" && (
         <>
          <div className="filter-inputLabel">
           <p className="filter-inputLabelText">Energy Rate (₹ per Unit)</p>
          </div>
          <div className="filter-slider">
           <Box>
            <Slider
             className="matchPercentage"
             name="landingCostRange"
             getAriaLabel={() => "Temperature range"}
             value={values.landingCostRange}
             onChange={(e) => {
              setFieldValue("landingCostRange", e.target.value);
             }}
             valueLabelDisplay="on"
             color="warning"
             size="small"
            />
           </Box>
          </div>
         </>
        )}
        <div className="filter-inputLabel">
         <p className="filter-inputLabelText">Energy Type</p>
        </div>
        <Box>
         <select
          name="energyTypeId"
          onChange={(e) => setFieldValue("energyTypeId", e.target.value)}
          value={values.energyTypeId}
          className="custom-selectInput-cr"
         >
          <option value="">Select Energy Type</option>
          {energyTypes?.map((item) => (
           <option key={item.id} value={item.id}>
            {item.type}
           </option>
          ))}
         </select>
        </Box>
        <div className="filter-inputLabel">
         <p className="filter-inputLabelText"> Credit Rating</p>
        </div>
        <Box>
         <select
          name="creditRatingId"
          onChange={(e) => setFieldValue("creditRatingId", e.target.value)}
          value={values.creditRatingId}
          className="custom-selectInput-cr"
         >
          <option value="">Credit Rating</option>
          {credit?.map((item) => (
           <option key={item.id} value={item.id}>
            {item.rating}
           </option>
          ))}
         </select>
        </Box>
        <div style={{ marginLeft: "15px" }}>
         <button
          type="submit"
          className="btn btn-signup btn-primary"
          disabled={selectedCardData ? false : true}
         >
          Apply
         </button>
        </div>
       </div>
      </Form>
     );
    }}
   </Formik>
  </>
 );
};

export default Filter;
